export const GROUP_RESERVATION_FLOW = Symbol('groupReservationFlow')
export const GTM_SOURCE_KEY = Symbol('gtmSource')
